import { FC } from 'react';
import Edit from 'components/segments/components/Edit';

const Screen: FC = () => {
  return (
    <Edit
      segmentsEntityName="client-segment"
      segmentsEndpoint="client-segments"
      elementsEntityName="client-elements"
      elementsEndpoint="client-elements"
      segmentFilter="client_segment_id"
    />
  );
};

export default Screen;
